window.components.modalPopup = {
    selector: "[popup-line-product]",

    init: function () {
        this.events();
    },

    events: function () {
        $(this.selector).on("click", ".backshadow", this.close);
        $(this.selector).on("click", ".popup-close", this.close);
        $(this.selector).on("click", ".popup-btn", this.close);

        $(this.selector).on("load").addClass("active");
    },

    close: function () {
        $(window.components.modalPopup.selector).removeClass("active");
    },
};
